const isValidHex = (str: string): boolean => {
    if (!str) {
        return false;
    }

    return /^#([0-9A-Fa-f]{3}){1,2}$/.test(str);
};

const hexToRgb = hex =>
    isValidHex(hex)
        ? hex
              .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`)
              .substring(1)
              .match(/.{2}/g)
              .map(x => parseInt(x, 16))
        : undefined;

const getRelativeLuminance = (color: string): number | undefined => {
    const rgb = hexToRgb(color);
    if (!rgb || rgb.length < 3) {
        return undefined;
    }

    const [r, g, b] = rgb.map(val => {
        const value = val / 255;

        return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
    });

    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export default getRelativeLuminance;
